import React, { useEffect, useState } from "react";
import Layout from "../../components/web/Layout";
import Container from "../../components/ui/container/Container";
import BreadCrump from "../../components/web/breadcrump/BreadCrump";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "../../store/slice/userActions";
import UserAuth from "../../middleware/UserAuth";
import placeHolderImage from "../../assets/images/placeholder/product.jpg";
import { FiMinus, FiPlus } from "react-icons/fi";
import { useFormik } from "formik";
import apiRequest from "../../utils/apiRequest";
import { ORDER_DEATILS_PRODUCT_ROUTE } from "../../routes/web/rootRoutes";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  generateTitle,
  getMainImageUrl,
  formatToINR,
} from "../../utils/helper";
import { IoTrash } from "react-icons/io5";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.user.cart);

  const [isPaying, setIsPaying] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [showScanPayModal, setShowScanPayModal] = useState(false);
  const [scanPayData, setScanPayData] = useState(null);


  const [taxSettings, setTaxSettings] = useState({
    is_vat: false,
    is_cgst: false,
    is_sgst: false,
  });


  useEffect(() => {
    const fetchVendorTax = async () => {
      try {
        const vendorId =
          cart?.products?.[0]?.product?.vendorManagerId;

        if (!vendorId) return;

        const res = await apiRequest.getVendorTaxSettings({
          vendorId,
        });

        if (res?.data?.response) {
          setTaxSettings({
            is_vat: res.data.data.is_vat || false,
            is_cgst: res.data.data.is_cgst || false,
            is_sgst: res.data.data.is_sgst || false,
          });
        }
      } catch (err) {
        toast.error("Failed to load tax settings");
      }
    };

    if (cart?.products?.length) {
      fetchVendorTax();
    }
  }, [cart]);
  const totalPrice = cart?.products?.reduce(
    (acc, curr) =>
      acc + (curr.quantity || 0) * (curr.product?.finalPrice || 0),
    0
  );

  const cgst = taxSettings.is_cgst
    ? cart?.products?.reduce(
      (acc, curr) =>
        acc +
        (curr.quantity || 0) *
        (curr.product?.finalPrice || 0) *
        0.025,
      0
    )
    : 0;


  const sgst = taxSettings.is_sgst
    ? cart?.products?.reduce(
      (acc, curr) =>
        acc +
        (curr.quantity || 0) *
        (curr.product?.finalPrice || 0) *
        0.025,
      0
    )
    : 0;

  const vat = taxSettings.is_vat
    ? cart?.products?.reduce(
      (acc, curr) =>
        acc +
        (curr.quantity || 0) *
        (curr.product?.finalPrice || 0) *
        0.10,
      0
    )
    : 0;



  const increaseQuantity = async (productId) =>
    await dispatch(addToCart({ productId, quantity: 1, type: "I" })).unwrap();

  const decreaseQuantity = async (productId) =>
    await dispatch(addToCart({ productId, quantity: 1, type: "D" })).unwrap();

  const removeItem = (id) => dispatch(removeFromCart(id));

  const formik = useFormik({
    initialValues: {
      paymentMethod: "",
      couponCode: "",
    },

    onSubmit: async (values) => {
      if (!values.paymentMethod) {
        toast.error("Please select a payment method");
        return;
      }

      const vendorId =
        cart?.products?.[0]?.product?.vendorManagerId;

      if (!vendorId) {
        toast.error("Vendor not found");
        return;
      }

      setIsPaying(true);



      try {
        if (values.paymentMethod === "razorpay") {
          const payload = {
            vendorId,
            products: cart.products.map((item) => ({
              productId: item.product._id,
              quantity: item.quantity,
              priceAtPurchase: item.product.finalPrice,
            })),
            subtotal: totalPrice,
            totalAmount: totalPrice,
            paymentMethod: "razorpay",

            couponCode: values.couponCode || undefined,
          };
          await handleRazorpayPayment(payload);
        }

        if (values.paymentMethod === "scan_pay") {
          const payload = {
            vendorId,
            products: cart.products.map((item) => ({
              productId: item.product._id,
              quantity: item.quantity,
              priceAtPurchase: item.product.finalPrice,
            })),
            subtotal: totalPrice,
            totalAmount: totalPrice,
            paymentMethod: "scan_pay",
            couponCode: values.couponCode || undefined,
          };

          await handleScanPayPayment(payload);
        }
      } catch (err) {
        toast.error(err?.message || "Payment failed");
      } finally {
        setIsPaying(false);
      }
    },
  });





  useEffect(() => {
    const fetchPaymentOptions = async () => {
      try {
        const vendorId =
          cart?.products?.[0]?.product?.vendorManagerId;

        if (!vendorId) return;

        const res = await apiRequest.getPaymentOptions({
          vendorId,
        });

        if (res?.data?.response) {
          const methods = res.data.data.methods || [];
          setPaymentOptions(methods);

          if (methods.length) {
            formik.setFieldValue(
              "paymentMethod",
              methods[0].id
            );
          }
        }
      } catch {
        toast.error("Failed to load payment options");
      }
    };

    if (cart?.products?.length) {
      fetchPaymentOptions();
    }
  }, [cart]);

  const user = useSelector((state) => state.globalState.userProfile);

  const handleRazorpayPayment = async (payload) => {
    const res = await apiRequest.createRazorpayOrder({
      body: payload,
    });

    const {
      keyId,
      razorpayOrderId,
      orderId,
      amount,
    } = res.data.data;

    const options = {
      key: keyId,
      amount: amount * 100,
      currency: "INR",
      order_id: razorpayOrderId,


      name: "MoboEat",
      description: "Order Payment",
      image: "https://moboeat.com/static/media/logo.7ee9e620560c0c86c1fa.jpg",

      order_id: razorpayOrderId,

      prefill: {
        name: user?.name || "Customer",
        email: user?.email || "customer@example.com",
        contact: user?.mobile || "9999999999",
      },

      theme: {
        color: "#F97316",
      },


      handler: async (response) => {
        const responseRazor = await apiRequest.verifyRazorpayPayment({
          body: {
            ...response,
            orderId,
            vendorId: payload.vendorId,
          },
        });

        toast.success("Payment successful");

        navigate(ORDER_DEATILS_PRODUCT_ROUTE(responseRazor?.data?.data?.orderId));
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const handleScanPayPayment = async (payload) => {
    const res = await apiRequest.createScanPayOrder({
      body: payload,
    });
    console.log(res?.data?.data);
    

    setScanPayData(res.data.data);
    setShowScanPayModal(true);
  };
  const [discountAmount, setDiscountAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [couponMessage, setCouponMessage] = useState("");
  const [couponLoading, setCouponLoading] = useState(false);


  /* ---------------- APPLY COUPON ---------------- */
  const handleApplyCoupon = async () => {
    if (!formik.values.couponCode) {
      toast.error("Enter coupon code");
      return;
    }

    try {
      setCouponLoading(true);

      const vendorId =
        cart?.products?.[0]?.product?.vendorManagerId;

      const res = await apiRequest.applyCoupon({
        body: {
          couponCode: formik.values.couponCode,
          orderAmount: totalPrice,
          vendorId,
        },
      });

      setDiscountAmount(res.data.data.discountAmount);
      setCouponMessage(res.data.message);
      toast.success(res.data.message);
    } catch (err) {
      setDiscountAmount(0);
      setCouponMessage("");
      toast.error(
        err?.response?.data?.message || "Invalid coupon"
      );
    } finally {
      setCouponLoading(false);
    }
  };


  return (
    <UserAuth>
      <Layout>
        <BreadCrump />
        <Container>
          <h2 className="my-4 text-2xl font-semibold text-center">
            Order Summary
          </h2>

          <form onSubmit={formik.handleSubmit}>
            <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
              {/* CART ITEMS */}
              <div className="p-4 bg-white md:col-span-2 border rounded-lg shadow-sm">
                {/* DESKTOP TABLE */}
                <div className="hidden md:block overflow-x-auto">
                  <table className="w-full text-sm border-collapse">
                    <thead className="bg-gray-100 text-gray-600">
                      <tr>
                        <th className="text-left p-3">Product</th>
                        <th className="text-center p-3">Qty</th>
                        <th className="text-right p-3">Price</th>
                        <th className="text-center p-3">Remove</th>
                      </tr>
                    </thead>

                    <tbody>
                      {cart?.products?.map((item, i) => (
                        <tr key={i} className="border-b hover:bg-gray-50">
                          <td className="flex items-center gap-3 p-3">
                            <img
                              src={getMainImageUrl(
                                item?.product?.image ?? placeHolderImage
                              )}
                              className="w-12 h-12 rounded object-cover border"
                              alt=""
                            />
                            <div className="font-medium">
                              {generateTitle(item.product)}
                            </div>
                          </td>

                          <td className="text-center">
                            <div className="inline-flex items-center border rounded-lg overflow-hidden">
                              <button
                                type="button"

                                onClick={() =>
                                  decreaseQuantity(item.product._id)
                                }
                                className="px-3 py-1 hover:bg-gray-100"
                              >
                                <FiMinus />
                              </button>

                              <span className="px-4 font-semibold">
                                {item.quantity}
                              </span>

                              <button
                                type="button"

                                onClick={() =>
                                  increaseQuantity(item.product._id)
                                }
                                className="px-3 py-1 hover:bg-gray-100"
                              >
                                <FiPlus />
                              </button>
                            </div>
                          </td>

                          <td className="text-right font-semibold p-3">
                            {formatToINR(
                              item.product.finalPrice * item.quantity
                            )}
                          </td>

                          <td className="text-center">
                            <p className="text-center">
                              <button
                                type="button"

                                className="cursor-pointer text-red-500 hover:text-red-600"
                                onClick={() =>
                                  removeItem(item.product._id)
                                }
                              >
                                <IoTrash size={18} className="cursor-pointer text-red-500 hover:text-red-600" />
                              </button>
                            </p>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* MOBILE CARDS */}
                <div className="md:hidden space-y-4">
                  {cart?.products?.map((item, i) => (
                    <div
                      key={i}
                      className="border rounded-lg p-3 flex gap-3 items-center"
                    >
                      <img
                        src={getMainImageUrl(
                          item.product.image ?? placeHolderImage
                        )}
                        className="w-14 h-14 rounded object-cover border"
                        alt=""
                      />

                      <div className="flex-1">
                        <div className="text-sm font-semibold line-clamp-2">
                          {generateTitle(item.product)}
                        </div>

                        <div className="flex justify-between items-center mt-2">
                          <div className="inline-flex items-center border rounded-lg overflow-hidden">
                            <button
                              type="button"
                              onClick={() =>
                                decreaseQuantity(item.product._id)
                              }
                              className="px-3 py-1"
                            >
                              <FiMinus />
                            </button>

                            <span className="px-3 font-semibold">
                              {item.quantity}
                            </span>

                            <button
                              type="button"

                              onClick={() =>
                                increaseQuantity(item.product._id)
                              }
                              className="px-3 py-1"
                            >
                              <FiPlus />
                            </button>
                          </div>

                          <div className="font-bold text-sm">
                            {formatToINR(
                              item.product.finalPrice * item.quantity
                            )}
                          </div>
                        </div>
                      </div>

                      <p className="text-center">

                        <IoTrash
                          className="text-red-500 text-lg cursor-pointer"
                          onClick={() =>
                            removeItem(item.product._id)
                          }
                        />
                      </p>
                    </div>
                  ))}
                </div>
              </div>


              <CartSummary
                subtotal={totalPrice}
                formik={formik}
                discountAmount={discountAmount}
                cgst={cgst}
                sgst={sgst}
                vat={vat}
                handleApplyCoupon={handleApplyCoupon}
                couponLoading={couponLoading}
                couponMessage={couponMessage}
                paymentOptions={paymentOptions}
                setFinalAmount={setFinalAmount}
                finalAmount={finalAmount}
                isPaying={isPaying}
                taxSettings={taxSettings}
              />
            </div>
          </form>
        </Container>

        {showScanPayModal && scanPayData && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center">
            <div className="bg-white p-4 rounded w-80 text-center">
              <h3 className="font-semibold mb-2">
                Scan & Pay
              </h3>

              <img
                src={
                  paymentOptions.find(
                    (p) => p.id === "scan_pay"
                  )?.qrImage
                }
                className="w-48 mx-auto"
                alt=""
              />

              <p className="mt-2 text-sm">
                Token No:{" "}
                <b>{scanPayData.tokenNo}</b>
              </p>
              
          


              <button
                className="mt-4 bg-green-600 text-white px-4 py-2 rounded"
                onClick={() =>
                  navigate(
                    ORDER_DEATILS_PRODUCT_ROUTE(
                      scanPayData.orderId
                    )
                  )
                }
              >
               Payment in process...
              </button>
            </div>
          </div>
        )}
      </Layout>
    </UserAuth>
  );
};

export default Cart;

const CartSummary = ({
  subtotal,
  formik,
  paymentOptions,
  handleApplyCoupon,
  couponLoading,
  couponMessage,
  isPaying,
  discountAmount,
  setFinalAmount,
  finalAmount,
  cgst,
  sgst,
  vat
}) => {
  useEffect(() => {
    setFinalAmount(subtotal - discountAmount + cgst + sgst + vat);
  }, [subtotal, discountAmount, setFinalAmount]);

  return (
    <div className="p-4 bg-white border rounded md:mb-4 pb-[3rem]">
      <h3 className="font-semibold mb-2">Order Summary</h3>

      <div className="flex justify-between pb-2">
        <span>Sub Total</span>
        <span>₹{(subtotal - cgst - sgst)?.toFixed(2)} </span>
      </div>
      <hr className="py-1" />

      <div className="flex justify-between pb-2">
        <span>Discount</span>
        <span>₹{discountAmount?.toFixed(2)}</span>
      </div>
      <hr className="py-1" />
      {
        sgst > 0
        && <>
          <div className="flex justify-between pb-2">
            <span>CGST(2.5%)</span>
            <span>₹{cgst?.toFixed(2)}</span>
          </div>
          <hr className="py-1" />
        </>
      }
      {
        sgst > 0
        && <>
          <div className="flex justify-between pb-2">
            <span>SGST(2.5%)</span>
            <span>₹{sgst?.toFixed(2)}</span>
          </div>
          <hr className="py-1" />

        </>
      }

      {
        vat > 0 &&
        <>
          <div className="flex justify-between pb-2">
            <span>VAT(10%)</span>
            <span>₹{vat?.toFixed(2)}</span>
          </div>
          <hr className="py-1" />
        </>
      }

      <div className="flex justify-between border-b pb-2 font-semibold">
        <span>Total</span>
        <span>₹{(subtotal - discountAmount)?.toFixed(2)}</span>
      </div>

      <div className="mt-4">
        <label className="text-sm">Coupon Code</label>
        <div className="flex gap-2 mt-1">
          <input
            name="couponCode"
            value={formik.values.couponCode}
            onChange={formik.handleChange}
            className="border px-3 py-2 flex-1 rounded-lg border-green-200"
            placeholder="Enter coupon"
          />
          <button
            type="button"
            onClick={handleApplyCoupon}
            disabled={couponLoading}
            className="bg-green-600 text-white px-4 rounded-lg"
          >
            {couponLoading ? "Applying" : "Apply"}
          </button>
        </div>

        {couponMessage && (
          <p className="text-green-600 text-xs mt-1">{couponMessage}</p>
        )}
      </div>

      <h4 className="text-sm font-bold mt-3 mb-2">Payment Method</h4>
      <div className="grid grid-cols-2 gap-4">
        {/* ONLINE PAYMENT */}
        <label
          className={`p-4 border rounded-xl text-center cursor-pointer transition ${formik.values.paymentMethod === "razorpay"
            ? "border-orange-500 ring-2 ring-orange-100"
            : "hover:border-gray-400"
            }`}
        >
          <input
            type="radio"
            name="paymentMethod"
            value="razorpay"
            onChange={formik.handleChange}
            checked={formik.values.paymentMethod === "razorpay"}
            className="hidden"
          />
          <img
            src="https://github.com/raviranjan81/gsap/blob/main/Screenshot%202025-12-22%20095129.png?raw=true"
            className="w-20 mx-auto mb-2"
            alt="Online Payment"
          />
          <div className="text-sm font-semibold text-gray-800">Online Payment</div>
          <div className="text-xs text-gray-500 mt-1">
            UPI • Debit Card • Credit Card • Sodexo
          </div>
        </label>

        {/* PAY AT COUNTER */}
        <label
          className={`p-4 border rounded-xl text-center cursor-pointer transition ${formik.values.paymentMethod === "scan_pay"
            ? "border-orange-500 ring-2 ring-orange-100"
            : "hover:border-gray-400"
            }`}
        >
          <input
            type="radio"
            name="paymentMethod"
            value="scan_pay"
            onChange={formik.handleChange}
            checked={formik.values.paymentMethod === "scan_pay"}
            className="hidden"
          />
          <img
            src="https://github.com/raviranjan81/gsap/blob/main/Screenshot%202025-12-22%20094552.png?raw=true"
            className="w-16 mx-auto mb-2"
            alt="Pay at Counter"
          />
          <div className="text-sm font-semibold text-gray-800">Pay at Counter</div>
          <div className="text-xs text-gray-500 mt-1">Scan QR at counter</div>
        </label>
      </div>

      <button
        type="submit"
        disabled={isPaying}
        className="w-full mt-4 bg-orange-600 text-white py-2 rounded"
      >
        {isPaying ? "Processing..." : "Pay Now"}
      </button>
    </div>
  );

}
